var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterTypeArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323657",
    d: "M10.063 7.875h-.876a.437.437 0 0 0-.437.438v3.062a.438.438 0 0 0 .875 0v-.437h.438a1.531 1.531 0 1 0 0-3.063m0 2.188h-.438V8.75h.438a.656.656 0 1 1 0 1.313m-2.626-1.75v3.062a.438.438 0 0 1-.875 0V8.313a.437.437 0 1 1 .875 0M5.25 11.375a.44.44 0 0 1-.437.438h-1.75a.438.438 0 0 1-.383-.657L4.056 8.75h-.993a.437.437 0 1 1 0-.875h1.75a.438.438 0 0 1 .382.656l-1.378 2.406h.995a.44.44 0 0 1 .438.438m6.435-6.872L8.622 1.44a.44.44 0 0 0-.31-.127h-5.25a.875.875 0 0 0-.874.875v3.937a.437.437 0 1 0 .874 0V2.188h4.813v2.625a.437.437 0 0 0 .438.437h2.624v.875a.438.438 0 0 0 .876 0V4.813a.44.44 0 0 0-.129-.31M8.75 4.375V2.806l1.569 1.569z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterTypeArchive);
export default __webpack_public_path__ + "static/media/filter-type-archive.6c3cebe12f2f2b82545fbd4bacb5a842.svg";
export { ForwardRef as ReactComponent };